import classNames from 'classnames'

import type { PropsWithChildren, ReactElement } from 'react'

import './styles.scss'

export interface Props {
  className?: string
  primaryColor?: string
  secondaryColor?: string
  title: string
}

const BuilderFormSection = ({
  children,
  className,
  primaryColor = '#ff5301',
  secondaryColor = '#ff53011a',
  title,
}: PropsWithChildren<Props>): ReactElement => {
  const classes = classNames('builder-form-section', className)

  return (
    <div className={classes} style={{ backgroundColor: secondaryColor, borderColor: primaryColor }}>
      <span className="builder-form-section__title" style={{ backgroundColor: primaryColor }}>
        <span className="builder-form-section__title__text">{title}</span>
      </span>
      <div className="builder-form-section__content">{children}</div>
    </div>
  )
}

export default BuilderFormSection
